export const MOMENT_FORMAT = {
  DATE_DAY: 'DD',
  DAY_NAME: 'dddd',
  MONTH_NAME: 'MMMM',
  MONTH_NUMBER: 'MM',
  MONTH_YEAR_NAME: 'MMMM YYYY',
  YEAR_MONTH: 'YYYY-MM',
  DATE: 'YYYY-MM-DD',
  DATE_FRENCH_FORMAT: 'DD-MM-YYYY',
  DATE_MONTH: 'MM_YYYY',
  FRENCH_DATE_WORD: 'DD MMMM YYYY',
  FRENCH_DATE: 'DD/MM/YYYY',
  FR_DATE_TIME_WITH_SECONDS: 'DD/MM/YYYY HH:mm:ss',
  FRENCH_DATE_TIME: 'DD/MM/YYYY HH:mm',
  FRENCH_HOUR_TIME: 'HH:mm',
  TIME: 'HH:mm:ss',
  TIMESTAMP: 'YYY-MM-DDTHH:mm:ssZ',
  TIME_WITH_MILLISECONDS: 'HH:mm:ss.SSS',
  FULL_DATE_FORMAT: 'YYYY-MM-DD HH:mm:ss',
  FULL_DATE_WITH_MILLISECONDS: 'YYYY-MM-DD HH:mm:ss.SSS',
  ISO_8601_WITH_MILLISECONDS: 'YYYY-MM-DDTHH:mm:ss.SSS[Z]',
  ISO_8601_WITHOUT_BRACKETS: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
  DATETIME_FORMAT: 'YYYY-MM-DDTHH:mm:ss',
  MONTH_YEAR: 'MMYYYY',
  FRENCH_FULL_WORD_DATE: 'dddd D MMMM YYYY',
  X: 'X',
  DAY_MONTH_YEAR: 'DDMMYY',
};

export const MOMENT_UNIT = {
  MINUTE: 'minutes',
  DAY: 'day',
};
